import axios from 'axios';
import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import * as Yup from "yup";
import Cookies from "js-cookie";
import { adminMainUrl } from '../../../../Config';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getOrganisationAgentList } from '../../../../Redux/action/Organisation/OrganisationListAction';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Table } from "antd";
import Beatloader from '../../../../Common/Loaders/Beatloader';
import { getMasterIATAAgentAddressList, getMasterIATAAgentContactList, getMasterIATAAgentCustomerList, getMasterIATAAgentDetail, getMasterIATAAgentSalesList } from '../../../../Redux/action/MasterAction';
import AddAddress from './Offcanvases/AddAddress';
import EditAddress from './Offcanvases/EditAddress';
import AddSales from './Offcanvases/AddSales';
import EditSales from './Offcanvases/EditSales';
import AddCustomer from './Offcanvases/AddCustomer';
import EditCustomer from './Offcanvases/EditCustomer';
import AddContact from './Offcanvases/AddContact';
import EditContact from './Offcanvases/EditContact';

const IATAAgentEdit = ({ accessedPermission }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    let { b64id } = useParams();
    const [disableSubmit, setDisableSubmit] = useState(false);
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;
    const [activeTab, setActiveTab] = useState("iata_agent");
    const [activeContactTab, setActiveContactTab] = useState("cd_sales_person");

    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id');
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        if (token && user_id) {
            if (b64id) {
                let iata_agent_id = atob(b64id);
                if (iata_agent_id) {
                    dispatch(getMasterIATAAgentDetail(token, user_id, iata_agent_id));
                    dispatch(getMasterIATAAgentAddressList(token, user_id, iata_agent_id));
                    dispatch(getMasterIATAAgentSalesList(token, user_id, iata_agent_id));
                    dispatch(getMasterIATAAgentCustomerList(token, user_id, iata_agent_id));
                    dispatch(getMasterIATAAgentContactList(token, user_id, iata_agent_id));
                }
            } else {
                toast.error("Please enter correct URL.");
                navigate(-1);
            }
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }, [token, user_id, b64id]);


    //handle modal offcanvas

    const [address_id, setAddress_id] = useState(0);
    const [sales_id, setSales_id] = useState(0);
    const [customer_id, setCustomer_id] = useState(0);
    const [contact_id, setContact_id] = useState(0);

    const [showAddAddress, setShowAddAddress] = useState(false);
    const handleAddAddressClose = () => setShowAddAddress(false);
    const handleAddAddressShow = () => setShowAddAddress(true);

    const [showEditAddress, setShowEditAddress] = useState(false);
    const handleEditAddressClose = () => setShowEditAddress(false);
    const handleEditAddressShow = (id) => {
        if (id) {
            setAddress_id(id);
            setShowEditAddress(true);
        } else {
            toast.error("Couldn't find addresss.")
        }
    }

    const [showAddSales, setShowAddSales] = useState(false);
    const handleAddSalesClose = () => setShowAddSales(false);
    const handleAddSalesShow = (id) => { setShowAddSales(true) };

    const [showEditSales, setShowEditSales] = useState(false);
    const handleEditSalesClose = () => setShowEditSales(false);
    const handleEditSalesShow = (id) => {
        if (id) {
            setSales_id(id);
            setShowEditSales(true);
        } else {
            toast.error("Couldn't find sales person details.")
        }
    }

    const [showAddCustomer, setShowAddCustomer] = useState(false);
    const handleAddCustomerClose = () => setShowAddCustomer(false);
    const handleAddCustomerShow = () => setShowAddCustomer(true);

    const [showEditCustomer, setShowEditCustomer] = useState(false);
    const handleEditCustomerClose = () => setShowEditCustomer(false);
    const handleEditCustomerShow = (id) => {
        if (id) {
            setCustomer_id(id);
            setShowEditCustomer(true);
        } else {
            toast.error("Couldn't find customer service details.")
        }
    }

    const [showAddContact, setShowAddContact] = useState(false);
    const handleAddContactClose = () => setShowAddContact(false);
    const handleAddContactShow = () => setShowAddContact(true);

    const [showEditContact, setShowEditContact] = useState(false);
    const handleEditContactClose = () => setShowEditContact(false);
    const handleEditContactShow = (id) => {
        if (id) {
            setContact_id(id);
            setShowEditContact(true);
        } else {
            toast.error("Couldn't find contact details.")
        }
    }


    const {
        loadingMasterIATAAgentList,
        MasterIATAAgentList,
        MasterIATAAgentListError,
        MasterIATAAgentListCurrentPage,
        MasterIATAAgentListTotalPage,
        MasterIATAAgentListTotalData,

        loadingMasterIATAAgentDetail,
        MasterIATAAgentDetail,
        MasterIATAAgentDetailError,

        loadingMasterIATAAgentAddressList,
        MasterIATAAgentAddressList,
        MasterIATAAgentAddressListError,

        loadingMasterIATAAgentSalesList,
        MasterIATAAgentSalesList,
        MasterIATAAgentSalesListError,

        loadingMasterIATAAgentCustomerList,
        MasterIATAAgentCustomerList,
        MasterIATAAgentCustomerListError,

        loadingMasterIATAAgentContactList,
        MasterIATAAgentContactList,
        MasterIATAAgentContactListError,

    } = useSelector(state => state.MasterReducer);

    const refresh = () => {
        if (token && user_id) {
            if (b64id) {
                let iata_agent_id = atob(b64id);
                if (iata_agent_id) {
                    dispatch(getMasterIATAAgentDetail(token, user_id, iata_agent_id));
                }
            } else {
                toast.error("Please enter correct URL.");
                navigate(-1);
            }
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    };
    const refreshAddress = () => {
        if (token && user_id) {
            if (b64id) {
                let iata_agent_id = atob(b64id);
                if (iata_agent_id) {
                    dispatch(getMasterIATAAgentAddressList(token, user_id, iata_agent_id));
                }
            } else {
                toast.error("Please enter correct URL.");
                navigate(-1);
            }
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    };
    const refreshSales = () => {
        if (token && user_id) {
            if (b64id) {
                let iata_agent_id = atob(b64id);
                if (iata_agent_id) {
                    dispatch(getMasterIATAAgentSalesList(token, user_id, iata_agent_id));
                }
            } else {
                toast.error("Please enter correct URL.");
                navigate(-1);
            }
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    };
    const refreshCustomer = () => {
        if (token && user_id) {
            if (b64id) {
                let iata_agent_id = atob(b64id);
                if (iata_agent_id) {
                    dispatch(getMasterIATAAgentCustomerList(token, user_id, iata_agent_id));
                }
            } else {
                toast.error("Please enter correct URL.");
                navigate(-1);
            }
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    };
    const refreshContact = () => {
        if (token && user_id) {
            if (b64id) {
                let iata_agent_id = atob(b64id);
                if (iata_agent_id) {
                    dispatch(getMasterIATAAgentContactList(token, user_id, iata_agent_id));
                }
            } else {
                toast.error("Please enter correct URL.");
                navigate(-1);
            }
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    };

    useEffect(() => {
        if (loadingMasterIATAAgentDetail) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }
    }, [loadingMasterIATAAgentDetail]);

    const initialValues = {
        name: "",
        iata_code: "",
        tds_rate: "",
        tds_remark: "",
        pan_number: "",
    };

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object({
            // name: Yup.string().required("Please enter name")
        }),
        onSubmit: (values, { resetForm }) => {
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': Cookies.get('token'),
                        'user_id': Cookies.get('flexichain_user_id')
                    }
                }
                let iata_agent_id = atob(b64id);
                if (iata_agent_id) {
                    values.id = Number(iata_agent_id)
                } else {
                    toast.error("Could not find IATA agent.");
                    return;
                }
                axios.post(`${adminMainUrl}/api/iata-agent/update`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            refresh();
                            // navigate(`/flexichain/organization/edit/${btoa(response.data.data.id)}`)
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });

    useEffect(() => {
        if (MasterIATAAgentDetail) {
            formik.setFieldValue("name", MasterIATAAgentDetail.name);
            formik.setFieldValue("iata_code", MasterIATAAgentDetail.iata_code);
            formik.setFieldValue("tds_rate", MasterIATAAgentDetail.tds_rate);
            formik.setFieldValue("tds_remark", MasterIATAAgentDetail.tds_remark);
            formik.setFieldValue("pan_number", MasterIATAAgentDetail.pan_number);
        }
    }, [MasterIATAAgentDetail]);


    const columnsAddress = [
        { title: "#", dataIndex: "sno", key: "sno" },
        { title: "Default", dataIndex: "is_default", key: "is_default" },
        { title: "Address 1", dataIndex: "address_one", key: "address_one" },
        { title: "Address 2", dataIndex: "address_two", key: "address_two" },
        { title: "City", dataIndex: "city", key: "city" },
        { title: "State", dataIndex: "state", key: "state" },
        { title: "Country", dataIndex: "country", key: "country" },
        { title: "Pin Code", dataIndex: "pincode", key: "pincode" },
        { title: "Contact Person", dataIndex: "contact_person_name", key: "contact_person_name" },
        { title: "Mobile No.", dataIndex: "mobile_no", key: "mobile_no" },
        { title: "GST State Name", dataIndex: "gst_state_name", key: "gst_state_name" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];

    const columnsSales = [
        { title: "#", dataIndex: "sno", key: "sno" },
        { title: "Company/Branch/Divison", dataIndex: "company_branch_division", key: "company_branch_division" },
        { title: "Branch", dataIndex: "branch_name", key: "branch_name" },
        { title: "Sales Person", dataIndex: "sales_person_name", key: "sales_person_name" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];

    const columnsCustomer = [
        { title: "#", dataIndex: "sno", key: "sno" },
        { title: "Company/Branch/Divison", dataIndex: "company_branch_division", key: "company_branch_division" },
        { title: "Branch", dataIndex: "branch_name", key: "branch_name" },
        { title: "Contact Person", dataIndex: "customer_service_name", key: "customer_service_name" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];

    const columnsContact = [
        { title: "#", dataIndex: "sno", key: "sno" },
        { title: "Company/Branch/Divison", dataIndex: "company_branch_division", key: "company_branch_division" },
        { title: "Branch", dataIndex: "branch_name", key: "branch_name" },
        { title: "Contact Person", dataIndex: "contact_person_name", key: "contact_person_name" },
        { title: "Designation", dataIndex: "designation", key: "designation" },
        { title: "Mobile No.", dataIndex: "mobile", key: "mobile" },
        { title: "Email", dataIndex: "email", key: "email" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];

    const [dataSourceAddress, setDataSourceAddress] = useState([]);
    const [dataSourceSales, setDataSourceSales] = useState([]);
    const [dataSourceCustomer, setDataSourceCustomer] = useState([]);
    const [dataSourceContact, setDataSourceContact] = useState([]);

    useEffect(() => {
        if (MasterIATAAgentAddressList) {
            let arr = [];
            MasterIATAAgentAddressList.map((val, index) => {
                arr.push({
                    sno: index + 1,
                    is_default: val.is_default ? "YES" : "NO",
                    address_one: val.address_one ?? "-",
                    address_two: val.address_two ?? "-",
                    city: val.iata_agent_city ? val.iata_agent_city.name : "-",
                    state: val.iata_agent_state ? val.iata_agent_state.name : "-",
                    country: val.iata_agent_country ? val.iata_agent_country.name : "-",
                    pincode: val.pincode ?? "-",
                    contact_person_name: val.contact_person_name ?? "-",
                    mobile_no: val.mobile ?? "-",
                    gst_state_name: val.iata_agent_gst_state ? val.iata_agent_gst_state.name : "-",
                    action: (
                        <>
                            <div className="dropdown table-action">
                                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                                    <i className="fa fa-ellipsis-v"></i>
                                </Link>
                                <div className="dropdown-menu dropdown-menu-right">
                                    <div className="dropdown-item cursor-pointer" onClick={() => handleEditAddressShow(val.id)} >
                                        <i className="ti ti-edit text-blue me-2"></i> Edit Address
                                    </div>
                                </div>
                            </div>
                        </>
                    )
                })
            });
            setDataSourceAddress(arr);
        } else {
            setDataSourceAddress([]);
        }
    }, [MasterIATAAgentAddressList]);

    useEffect(() => {
        if (MasterIATAAgentSalesList) {
            let arr = [];
            MasterIATAAgentSalesList.map((val, index) => {
                arr.push({
                    sno: index + 1,
                    company_branch_division: val.company_branch_division ?? "-",
                    branch_name: val.branch_name ?? "-",
                    sales_person_name: val.sales_person_name ?? "-",
                    action: (
                        <>
                            <div className="dropdown table-action">
                                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                                    <i className="fa fa-ellipsis-v"></i>
                                </Link>
                                <div className="dropdown-menu dropdown-menu-right">
                                    <div className="dropdown-item cursor-pointer" onClick={() => handleEditSalesShow(val.id)} >
                                        <i className="ti ti-edit text-blue me-2"></i> Edit
                                    </div>
                                </div>
                            </div>
                        </>
                    )
                })
            });
            setDataSourceSales(arr);
        } else {
            setDataSourceSales([]);
        }
    }, [MasterIATAAgentSalesList]);

    useEffect(() => {
        if (MasterIATAAgentCustomerList) {
            let arr = [];
            MasterIATAAgentCustomerList.map((val, index) => {
                arr.push({
                    sno: index + 1,
                    company_branch_division: val.company_branch_division ?? "-",
                    branch_name: val.branch_name ?? "-",
                    customer_service_name: val.customer_service_name ?? "-",
                    action: (
                        <>
                            <div className="dropdown table-action">
                                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                                    <i className="fa fa-ellipsis-v"></i>
                                </Link>
                                <div className="dropdown-menu dropdown-menu-right">
                                    <div className="dropdown-item cursor-pointer" onClick={() => handleEditCustomerShow(val.id)} >
                                        <i className="ti ti-edit text-blue me-2"></i> Edit
                                    </div>
                                </div>
                            </div>
                        </>
                    )
                })
            });
            setDataSourceCustomer(arr);
        } else {
            setDataSourceCustomer([]);
        }
    }, [MasterIATAAgentCustomerList]);

    useEffect(() => {
        if (MasterIATAAgentContactList) {
            let arr = [];
            MasterIATAAgentContactList.map((val, index) => {
                arr.push({
                    sno: index + 1,
                    company_branch_division: val.company_branch_division ?? "-",
                    branch_name: val.branch_name ?? "-",
                    contact_person_name: val.contact_person_name ?? "-",
                    designation: val.designation ?? "-",
                    email: val.email ?? "-",
                    mobile: val.mobile ?? "-",
                    action: (
                        <>
                            <div className="dropdown table-action">
                                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                                    <i className="fa fa-ellipsis-v"></i>
                                </Link>
                                <div className="dropdown-menu dropdown-menu-right">
                                    <div className="dropdown-item cursor-pointer" onClick={() => handleEditContactShow(val.id)} >
                                        <i className="ti ti-edit text-blue me-2"></i> Edit
                                    </div>
                                </div>
                            </div>
                        </>
                    )
                })
            });
            setDataSourceContact(arr);
        } else {
            setDataSourceContact([]);
        }
    }, [MasterIATAAgentContactList])

    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <div className="page-wrapper">
                        <div className="content">
                            <div className="row">
                                <h4>Edit IATA Agent</h4>
                            </div>
                            <div className="row-gap-2">
                                <div className="tab-content" id="pills-tabContent">
                                    <Tabs
                                        activeKey={activeTab} // Controlled by state
                                        onSelect={(k) => setActiveTab(k)} // Update state on tab change
                                        transition={false}
                                        id="noanim-tab-example"
                                        className="nav nav-pills mb-3 custom-tabs gap-0"
                                    >
                                        <Tab eventKey="iata_agent" title="IATA Agent" className="nav-item" disabled={false}>
                                            <div className="card">
                                                <div className="card-body">
                                                    {/* Filter */}
                                                    <form onSubmit={formik.handleSubmit} >


                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <label htmlFor="name" className='form-label mb-0'>
                                                                    Name
                                                                </label>
                                                                <input
                                                                    className="form-control form-control-sm"
                                                                    id="name"
                                                                    name='name'
                                                                    value={formik.values.name}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    maxLength={250}
                                                                />

                                                            </div>
                                                            <div className="col-md-6">
                                                                <label htmlFor="iata_code" className='form-label mb-0'>
                                                                    IATA Code
                                                                </label>
                                                                <input
                                                                    className="form-control form-control-sm"
                                                                    id="iata_code"
                                                                    name='iata_code'
                                                                    value={formik.values.iata_code}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    maxLength={5}
                                                                />

                                                            </div>
                                                            <div className="col-md-6">
                                                                <label htmlFor="tds_rate" className='form-label mb-0'>
                                                                    TDS Rate
                                                                </label>
                                                                <input
                                                                    className="form-control form-control-sm"
                                                                    id="tds_rate"
                                                                    name='tds_rate'
                                                                    value={formik.values.tds_rate}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    maxLength={250}
                                                                />

                                                            </div>
                                                            <div className="col-md-6">
                                                                <label htmlFor="tds_remark" className='form-label mb-0'>
                                                                    TDS Remarks
                                                                </label>
                                                                <textarea
                                                                    className="form-control"
                                                                    id="tds_remark"
                                                                    name='tds_remark'
                                                                    value={formik.values.tds_remark}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                ></textarea>

                                                            </div>
                                                            <div className="col-md-6">
                                                                <label htmlFor="pan_number" className='form-label mb-0'>
                                                                    PAN Number
                                                                </label>
                                                                <input
                                                                    className="form-control form-control-sm"
                                                                    id="pan_number"
                                                                    name='pan_number'
                                                                    value={formik.values.pan_number}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    maxLength={10}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="row d-flex justify-content-end">
                                                            <div className="col-md-6 d-flex justify-content-end">
                                                                <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                                                    {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Update"}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                            <div className="card">
                                                <div className='card-body'>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <h4>Address</h4>
                                                        </div>
                                                        <div className="col-md-6 text-end">
                                                            <button type='button' className="btn btn-sm btn-primary" onClick={() => { handleAddAddressShow(true) }}>
                                                                + Add Address
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="table-responsive custom-table query-list-table">
                                                        <Table className="table datanew dataTable no-footer"
                                                            dataSource={dataSourceAddress}
                                                            columns={columnsAddress}
                                                            pagination={false}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Tab>
                                        <Tab eventKey="contact_details" title="Contact Details" className="nav-item" disabled={false} >
                                            <Tabs
                                                activeKey={activeContactTab} // Controlled by state
                                                onSelect={(k) => setActiveContactTab(k)} // Update state on tab change
                                                transition={false}
                                                id="noanim-tab-example"
                                                className="nav nav-pills mb-3 custom-tabs gap-0"
                                            >
                                                <Tab eventKey="cd_sales_person" title="Sales Person" className="nav-item" disabled={false}>
                                                    <div className="card">
                                                        <div className='card-body'>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <h4>Sales Person</h4>
                                                                </div>
                                                                <div className="col-md-6 text-end">
                                                                    <button type='button' className="btn btn-sm btn-primary" onClick={() => { handleAddSalesShow(true) }}>
                                                                        + Add
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className="table-responsive custom-table query-list-table">
                                                                <Table className="table datanew dataTable no-footer"
                                                                    dataSource={dataSourceSales}
                                                                    columns={columnsSales}
                                                                    pagination={false}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Tab>
                                                <Tab eventKey="cd_customer_service" title="Customer Service" className="nav-item" disabled={false}>
                                                    <div className="card">
                                                        <div className='card-body'>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <h4>Customer Service</h4>
                                                                </div>
                                                                <div className="col-md-6 text-end">
                                                                    <button type='button' className="btn btn-sm btn-primary" onClick={() => { handleAddCustomerShow(true) }}>
                                                                        + Add
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className="table-responsive custom-table query-list-table">
                                                                <Table className="table datanew dataTable no-footer"
                                                                    dataSource={dataSourceCustomer}
                                                                    columns={columnsCustomer}
                                                                    pagination={false}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Tab>
                                                <Tab eventKey="cd_contact_details" title="Contact Details" className="nav-item" disabled={false}>
                                                    <div className="card">
                                                        <div className='card-body'>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <h4>Contact Details</h4>
                                                                </div>
                                                                <div className="col-md-6 text-end">
                                                                    <button type='button' className="btn btn-sm btn-primary" onClick={() => { handleAddContactShow(true) }}>
                                                                        + Add
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className="table-responsive custom-table query-list-table">
                                                                <Table className="table datanew dataTable no-footer"
                                                                    dataSource={dataSourceContact}
                                                                    columns={columnsContact}
                                                                    pagination={false}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Tab>
                                            </Tabs>
                                        </Tab>
                                    </Tabs>
                                </div>
                            </div>
                        </div>
                        <AddAddress
                            token={token}
                            user_id={user_id}
                            b64id={b64id}
                            show={showAddAddress}
                            handleClose={handleAddAddressClose}
                            refreshAddress={refreshAddress}
                        />

                        <EditAddress
                            address_id={address_id}
                            token={token}
                            user_id={user_id}
                            b64id={b64id}
                            show={showEditAddress}
                            handleClose={handleEditAddressClose}
                            refreshAddress={refreshAddress}
                        />

                        <AddSales
                            token={token}
                            user_id={user_id}
                            b64id={b64id}
                            show={showAddSales}
                            handleClose={handleAddSalesClose}
                            refreshSales={refreshSales}
                        />
                        <EditSales
                            sales_id={sales_id}
                            token={token}
                            user_id={user_id}
                            b64id={b64id}
                            show={showEditSales}
                            handleClose={handleEditSalesClose}
                            refreshSales={refreshSales}
                        />

                        <AddCustomer
                            token={token}
                            user_id={user_id}
                            b64id={b64id}
                            show={showAddCustomer}
                            handleClose={handleAddCustomerClose}
                            refreshCustomer={refreshCustomer}
                        />
                        <EditCustomer
                            customer_id={customer_id}
                            token={token}
                            user_id={user_id}
                            b64id={b64id}
                            show={showEditCustomer}
                            handleClose={handleEditCustomerClose}
                            refreshCustomer={refreshCustomer}
                        />

                        <AddContact
                            token={token}
                            user_id={user_id}
                            b64id={b64id}
                            show={showAddContact}
                            handleClose={handleAddContactClose}
                            refreshContact={refreshContact}
                        />
                        <EditContact
                            contact_id={contact_id}
                            token={token}
                            user_id={user_id}
                            b64id={b64id}
                            show={showEditContact}
                            handleClose={handleEditContactClose}
                            refreshContact={refreshContact}
                        />
                    </div>


                // Offcanvas
            }
        </>
    )
}

export default IATAAgentEdit